import React, { useEffect } from 'react';
// import { rotate, zif, ZifData } from '../config.js';
import '../App.css'
import Z from '.././js/ZoomifyImageViewerEnterprise-src'
const TwoViewer = ({ CurrentLevel, Canvas, src, layer,rotate, zif, ZifData }) => {
    console.log(CurrentLevel);
    const getlay = (layer) => {
        if (layer == 'Coronal sections') {
            return 'z'
        }
        if (layer == 'Sagittal sections') {
            return 'x'
        }
        if (layer == 'Horizontal sections') {
            return 'y'
        }
    }
    function getZifCount(layer, count) {
        const direction = layer.split(' ')[0];

        // 检查是否有指定方向的数据
        if (ZifData[direction]) {
            const directionData = ZifData[direction];
            // 根据给定的层数计算 "zif" 张数
            const zifStart = parseInt(directionData.zif_start, 10);
            var desiredZif
            // 计算对应层数的 "zif" 张数
            if (direction == 'Coronal') {
                desiredZif = parseInt(zifStart + count);
            }
            else {
                desiredZif = parseInt(zifStart + count * 20);
            }
            // 返回结果
            return desiredZif.toString().padStart(5, '0');
        }
    }


    useEffect(() => {
        if (!zif) {
            const loadAndDrawCanvas = (Canvas, imageSrc) => {
                const canvas = Canvas.current;
                const image = new Image();
                image.src = imageSrc;
                image.onload = () => {
                    canvas.width = image.width;
                    canvas.height = image.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(image, 0, 0, image.width, image.height);
                    ctx.rotate(rotate.x * Math.PI / 180);
                };
            };

            loadAndDrawCanvas(Canvas, src);
        }
        else {
            const zifURL = `/${getlay(layer)}/${getZifCount(layer, CurrentLevel)}.zif`
            console.log(zifURL);
            Z.showImage(
                "zoomify-container",
                zifURL
            );
        }
    }, [src, CurrentLevel]);

    if (!zif) {
        return (
            <canvas ref={Canvas}></canvas>
        );
    }
    else {
        return (
            <div id="zoomify-container"></div>
        );
    }
};

export default TwoViewer;
